import { ModalBottomButtons, TextArea } from '@bp/ui-components';
import { Form, Formik, FormikHelpers } from 'formik';
import { useActivityProtocol } from 'hooks/matrix/useActivityProtocol';
import { useTranslation } from 'react-i18next';
import { NotificationReason } from 'utils/matrixClient';

type SubmissionPublicationRequestFormType = {
  reason: string | null;
};

type SubmissionPublicationRequestFormProps = {
  submissionUuid: string;
  name: string;
  onLoading: (loading: boolean) => void;
  onClose: () => void;
};

export const SubmissionPublicationRequestForm = ({
  submissionUuid,
  name,
  onLoading,
  onClose,
}: SubmissionPublicationRequestFormProps) => {
  const { t } = useTranslation();

  const { sendMessage } = useActivityProtocol();

  const initialValues: SubmissionPublicationRequestFormType = {
    reason: null,
  };

  async function handleSubmit(
    values: SubmissionPublicationRequestFormType,
    helpers: FormikHelpers<SubmissionPublicationRequestFormType>,
  ) {
    onLoading(true);
    await sendMessage(submissionUuid, NotificationReason.SubmissionRequestToPublish, values.reason);
    onLoading(false);
    helpers.resetForm();
    onClose();
  }

  return (
    <Formik<SubmissionPublicationRequestFormType> initialValues={initialValues} onSubmit={handleSubmit}>
      {({ setFieldValue, values }) => (
        <Form>
          <TextArea
            className='mb-2'
            label={t('common.reason')}
            onChange={(e) => setFieldValue('reason', e.target.value)}
            value={values.reason ?? undefined}
            name='reason'
            rows={4}
            isScrollable
          />
          <div>{t('submissions.willBePublic', { name })}</div>
          <ModalBottomButtons closeButton={{ callback: () => onClose() }} />
        </Form>
      )}
    </Formik>
  );
};
